import type { CoverInfo } from './case-rows.js';
import { fetchPropertyCovers } from './properties.js';

/**
 * Nahledy nemovitosti pro seznamy zakazek. Do kroku UXR1 zil tenhle kod jen
 * v `routes/zakazky.tsx`; Dnesek ukazuje tytez nahledy, takze by se jinak
 * logika zkopirovala podruhe a jedna z kopii by casem zaostala.
 *
 * ---------------------------------------------------------------------------
 * Krok UXV4a bod 4 — ODSUD ZMIZEL DOPOCET VYREZU OBCE.
 *
 * Do UX v4 se tu po nactení fotek a souradnic jeste dohledaval STRED OBCE
 * (`lib/municipality.ts`, krok DEMO2) jako posledni zaloha nahledu. Predloha
 * UX v4 § Pravidla 3 rika „**Nikdy stred obce**" (a TAB1 to uz jednou vypnul
 * na kartach zakazek — „Vrsovicka 74" ukazovala stred Prahy), takze tu
 * uroven uz zadna obrazovka nekresli. Dopocet byl rada dotazu na napovedu
 * adres pro udaj, ktery nikdo nezobrazi — proto je pryc i s modulem, ktery
 * ho delal. Posledni uroven kaskady je dnes veta „Fotka po nahrání"
 * (`lib/property-image.ts`).
 * ---------------------------------------------------------------------------
 */
export async function loadCaseCovers(
  propertyIds: readonly string[],
  onPartial?: (covers: ReadonlyMap<string, CoverInfo>) => void,
): Promise<ReadonlyMap<string, CoverInfo>> {
  if (propertyIds.length === 0) return new Map();
  const items = await fetchPropertyCovers([...propertyIds]);
  const covers = new Map<string, CoverInfo>(
    items.map((item) => [
      item.propertyId,
      { propertyId: item.propertyId, thumbUrl: item.thumbUrl, lat: item.lat, lon: item.lon },
    ]),
  );
  onPartial?.(covers);
  return covers;
}
